var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowAvatarBubbleMobile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "14px",
    viewBox: "0 0 8 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLeftArrowCallAvatarBubbleMobile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.18959489,7.00255537 L7.71783382,2.47993496 C7.84251932,2.35570443 7.91111111,2.18960506 7.91111111,2.01249792 C7.91111111,1.8352925 7.84251932,1.66929142 7.71783382,1.54486432 L7.3210446,1.14878121 C7.19655591,1.02415754 7.03014456,0.955555556 6.85280969,0.955555556 C6.67547483,0.955555556 6.50926029,1.02415754 6.3846732,1.14878121 L0.993083107,6.53334923 C0.868003964,6.65816947 0.799510586,6.82495682 0.800002637,7.00226052 C0.799510586,7.1803505 0.867905554,7.34694128 0.993083107,7.4718598 L6.37965429,12.8512188 C6.50424138,12.9758425 6.67045591,13.0444444 6.84788919,13.0444444 C7.02522406,13.0444444 7.19143859,12.9758425 7.31612409,12.8512188 L7.71281491,12.4551357 C7.97094441,12.1973377 7.97094441,11.7776665 7.71281491,11.5199668 L3.18959489,7.00255537 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Call-incoming---incoming-call-popup-from-edge",
    transform: "translate(-278.000000, -499.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(278.000000, 470.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icLeftArrowCallAvatarBubbleMobile",
    transform: "translate(0.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    mask: "url(#mask-2)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.000000, -9.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 32 0 32 32 0 32"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowAvatarBubbleMobile);
export default __webpack_public_path__ + "static/media/icArrowAvatarBubbleMobile.b955f0be9b8d3893c928e9a2ae941e85.svg";
export { ForwardRef as ReactComponent };